import React from 'react';
import { Link } from 'react-router-dom';
import AppFooter from './AppFooter';
import './PolicyPage.css';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <img src="/white_wide_logo_noBG.png" alt="GallopAI" className="policy-logo" />
        <h1 className="policy-title">Terms & Conditions</h1>
        <p className="policy-updated">Last Updated: 19 November, 2025</p>
      </div>
      
      <div className="policy-content">
        <div className="policy-card">
          <div className="policy-section">
            <h2 className="policy-section-title">Introduction</h2>
            <p className="policy-text">
              By using GallopAI's website, products, and services ("Products"), you agree to be bound by these Terms and Conditions ("Terms") and our Privacy Policy. If you do not agree to these Terms, please do not use our Products.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Definitions</h2>
            <h3 className="policy-subsection-title">Parties</h3>
            <p className="policy-text">
              "You" and "your" refer to you, as a user of our Products. "We," "us," and "our" refer to GallopAI.
            </p>
            <h3 className="policy-subsection-title">Products</h3>
            <p className="policy-text">
              Our "Products" include our automated horse racing system, website, and all related services.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Eligibility</h2>
            <p className="policy-text">
              You may access or use our Products only if you:
            </p>
            <ul className="policy-list">
              <li>Are at least 18 years old</li>
              <li>Are legally permitted to use gambling services in your jurisdiction</li>
              <li>Have a valid Betfair account</li>
              <li>Have the authority to enter into these Terms</li>
              <li>Are not a competitor or using our Products for competitive analysis</li>
              <li>Have not been previously banned from our Products</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Account Terms</h2>
            <p className="policy-text">
              To use our Products, you must:
            </p>
            <ul className="policy-list">
              <li>Create an account with accurate information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Promptly notify us of any unauthorized access</li>
              <li>Take responsibility for all activities under your account</li>
              <li>Not create multiple accounts or transfer your account to others</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Betting System Usage</h2>
            <p className="policy-text">
              When using our betting system, you acknowledge and agree that:
            </p>
            <ul className="policy-list">
              <li>The ai system operates automatically based on predefined algorithms</li>
              <li>Past performance does not guarantee future results</li>
              <li>You are responsible for setting appropriate risk limits</li>
              <li>You must maintain sufficient funds in your Betfair account</li>
              <li>We are not responsible for any losses incurred</li>
              <li>Technical issues may affect system performance</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Payment and Subscription</h2>
            <p className="policy-text">
              By subscribing to our Products:
            </p>
            <ul className="policy-list">
              <li>You agree to pay all applicable fees</li>
              <li>Subscriptions auto-renew unless cancelled</li>
              <li>Refunds are subject to our Refund Policy</li>
              <li>We may modify pricing with notice</li>
              <li>Trial periods are limited to one per user</li>
            </ul>
            <p className="policy-text">
              To learn more about Betfair's Charges, please visit{' '}
              <a href="https://www.betfair.com/www/GBR/en/aboutUs/Betfair.Charges/" target="_blank" rel="noopener noreferrer" className="policy-link">
                Betfair's Charges
              </a>
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Restrictions</h2>
            <p className="policy-text">
              You agree not to:
            </p>
            <ul className="policy-list">
              <li>Reverse engineer our Products</li>
              <li>Attempt to access unauthorized areas</li>
              <li>Use our Products for illegal activities</li>
              <li>Share your account credentials</li>
              <li>Interfere with our services</li>
              <li>Circumvent any limitations</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Disclaimer</h2>
            <p className="policy-text">
              Our Products are provided "AS IS" without warranty. We do not guarantee:
            </p>
            <ul className="policy-list">
              <li>Specific betting outcomes or profits</li>
              <li>Continuous, uninterrupted service</li>
              <li>Accuracy of race analysis</li>
              <li>Betfair API availability</li>
            </ul>
            <p className="policy-text">
              <strong>Gambling involves significant risk of loss. Never bet more than you can afford to lose.</strong>
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Limitation of Liability</h2>
            <p className="policy-text">
              To the maximum extent permitted by law, GallopAI shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or goodwill, resulting from your use of our Products.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Changes to Terms</h2>
            <p className="policy-text">
              We may modify these Terms at any time. Continued use of our Products after changes constitutes acceptance of the modified Terms. We will notify you of material changes via email or through our Products.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Contact Us</h2>
            <p className="policy-text">
              For questions about these Terms, please contact us through our{' '}
              <Link to="/contact" target="_blank" rel="noopener noreferrer" className="policy-link">
                support page
              </Link>.
            </p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  );
};

export default TermsAndConditions;

